import { Component, ComponentFactoryResolver, ElementRef, OnInit, QueryList, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralService } from 'src/app/core/services/general/general.service';
import { BuscadorCursosComponent } from '../../componentes/buscador-cursos/buscador-cursos.component';
import { AreasDeConocimientoComponent } from 'src/app/shared/widgets/areas-de-conocimiento/areas-de-conocimiento.component';
import { PortadaComponent } from 'src/app/shared/widgets/portada/portada.component';
import { FormasDeContactoDosComponent } from 'src/app/shared/widgets/formas-de-contacto/formas-de-contacto-dos.component';
import { LoaderService } from 'src/app/core/load/load.service';
import { NuestrasSedesComponent } from 'src/app/shared/widgets/nuestras-sedes/nuestras-sedes.component';
import { lastValueFrom, take } from 'rxjs';
@Component({
  selector: 'app-cursos-listado',
  templateUrl: './cursos-listado.component.html',
  styleUrls: ['./cursos-listado.component.scss']
})
export class CursosListadoComponent implements OnInit {

  @ViewChildren('dynamicContainer', { read: ViewContainerRef }) containers!: QueryList<ViewContainerRef>;
  @ViewChildren('lazyWrapper', { read: ElementRef }) wrappers!: QueryList<ElementRef>;
  pages: any[] = [];
  nextIndex = 0;

  id: any;
  language: any;

  refBuscador;
  areaRecomendadaPending: any;
  constructor(private services: GeneralService, private router: Router, private activatedRoute: ActivatedRoute, private componentFactoryResolver: ComponentFactoryResolver, public venueService: GeneralService, public title: Title, public meta: Meta,
    private loader: LoaderService,) {
    this.loader.setLoading(true);
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.clearUrl()
    this.services.getSimplepage(this.id, this.language).subscribe(res => {
      // Convertimos el objeto de páginas en un array
      this.pages = Object.keys(res.data[0].pages)
        .filter(key => !isNaN(Number(key)))
        .map(key => res.data[0].pages[key][0]);

      let pagePending = this.pages.find(p => p.entityType == "AreaRecomendada")
      this.services.getEntities(pagePending.route + '&locale=' + this.language).subscribe(data => {
        this.areaRecomendadaPending = data.data;
      })
      this.pages = this.pages.filter(p => p.entityType !== "AreaRecomendada");
      // 🔹 Pre-cargar entidades
      this.preloadEntities().then(() => {
        // 🔹 Cuando todas estén listas, iniciar lazy load
        setTimeout(() => this.initSequentialLazyLoad(), 0);
      });
    })
  }
  preloadedData: any;
   preloadEntities(): Promise<void> {
      const requests = this.pages.map(page => {
        const url = page.route + '&locale=' + this.language;
  
        return lastValueFrom(
          this.services.getEntities(url).pipe(take(1))
        ).catch(error => {
          console.error(`Error cargando la ruta: ${url}`, error);
          return null;
        });
      });
  
      return Promise.all(requests).then(results => {
        this.preloadedData = results;
      }).catch(err => {
        console.error("Error crítico en Promise.all:", err);
      });
    }
  initSequentialLazyLoad() {
    // Asegurarse de que nextIndex arranca en 0
    this.nextIndex = 0;

    const wrappersArray = this.wrappers.toArray();

    const loadNext = (index: number) => {
      if (index >= this.pages.length) {
        this.loader.setLoading(false);
        return
      };

      const wrapper = wrappersArray[index];
      if (!wrapper) return;

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Cargar datos
            const page = this.pages[index];

            const data = this.preloadedData[index];
            this.newComponent(index, page.entityType, data);

            // Fade-in al aparecer
            const currentWrapper = wrappersArray[index].nativeElement;
            currentWrapper.classList.add('loaded');
            (currentWrapper as HTMLElement).style.minHeight = "0px";


            // Avanzar al siguiente
            loadNext(index + 1);


            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0 }); // threshold 0 para disparar apenas aparece

      observer.observe(wrapper.nativeElement);
    };

    // arrancamos con el primero
    loadNext(this.nextIndex);
  }


  newComponent(index: number, type: string, info: any) {
    const container = this.containers.toArray()[index]; // obtenemos el ViewContainerRef correspondiente
    let ref: any;
    let factory;
    switch (type) {

      case 'Buscador': {
        factory = this.componentFactoryResolver.resolveComponentFactory(BuscadorCursosComponent);
        ref = container.createComponent(factory);
        //ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.instance.data = info.data;
        ref.instance.translateY = '52%';
        ref.instance.padding = "30px 38.6px 30px 38.6px";
        ref.changeDetectorRef.detectChanges();
        this.refBuscador = ref;
        // aplicamos AreaRecomendada si estaba pendiente
        if (this.areaRecomendadaPending) {
          this.refBuscador.instance.infoAreaRecomendada = this.areaRecomendadaPending;
          this.refBuscador.changeDetectorRef.detectChanges();
          this.areaRecomendadaPending = null;
        }
      }
        break;
      case "Portada": {
        factory = this.componentFactoryResolver.resolveComponentFactory(PortadaComponent);
        ref = container.createComponent(factory);
        //ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.instance.data = info.data[0];

      }
        break;
      case "Area": {
        factory = this.componentFactoryResolver.resolveComponentFactory(AreasDeConocimientoComponent);
        ref = container.createComponent(factory);
        //  ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.instance.data = info.data[0];
        ref.instance.fondo = "Fondo-cursos.png";
        ref.instance.fondoMob = "fondo-continua-mobile.jpg";
        ref.instance.cursos = true
        // Llamamos al método del Buscador
        if (this.refBuscador && this.refBuscador.instance.spaceBetweenElements) {
          this.refBuscador.instance.spaceBetweenElements();
        }
        ref.changeDetectorRef.detectChanges();

      }
        break;

      case "Contacto": {
        factory = this.componentFactoryResolver.resolveComponentFactory(FormasDeContactoDosComponent);
        ref = container.createComponent(factory);
        // ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.instance.data = info.data;
        ref.instance.fondo = "Fondo1.png";
        ref.instance.fondoMob = "fondo-mobile.jpg";
        ref.instance.esCurso = true
        ref.changeDetectorRef.detectChanges();
      }
        break;
      case "Headquarters": {
        factory = this.componentFactoryResolver.resolveComponentFactory(NuestrasSedesComponent);
        ref = container.createComponent(factory);

        ref.instance.data = info.data[0].headquarters;
        ref.instance.sedes = info.data[0].sedes;
      }
        break;

    }
  }
  clearUrl() {
    let relativeUrl = this.router.url.split('?')[0]; // Elimina los parámetros de la consulta
    this.language = (this.activatedRoute.snapshot.params['language']) ? this.activatedRoute.snapshot.params['language'] : 'es';
    if (this.language) {
      relativeUrl = relativeUrl.replace(`/${this.language}/`, '/').replace(`/${this.language}`, '/');
    }
    this.id = relativeUrl.startsWith('/') ? relativeUrl.substring(1) : relativeUrl;
  }
}